


















































































































































import { Button, CollapseItem } from 'element-ui'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'

import CustomMoneyInput from '@/components/CustomMoneyInput.vue'
import DepositPaymentOption from '@/components/modals/DepositPaymentOption.vue'
import OptionAccordion from '@/components/OptionAccordion.vue'
import StepOptionRadio from '@/components/StepOptionRadio.vue'

import AmountChoice from '@/models/amount-choice'
import Booking from '@/models/booking'

import dayjs, { Dayjs } from '@/dayjs'
import { UtilityGetters } from '@/store/modules/utility'

@Component({
  components: {
    [Button.name]: Button,
    [CollapseItem.name]: CollapseItem,
    OptionAccordion,
    CustomMoneyInput,
    DepositPaymentOption,
    StepOptionRadio,
  },
})
export default class MakePaymentAmountStep extends Vue {
  @Prop() booking!: Booking
  @Prop() amountToPay!: number
  @Prop({ default: '' }) enteredPartialAmount!: string
  @Prop() depositsAmount!: number
  @Prop(String) parentAmountChoice!: AmountChoice | null
  @Prop({ default: 1 }) passengerCount!: number
  @Prop({ default: 1 }) maxDeposits!: number

  hasExplicitChoice = false

  collapseActiveName = ''

  get amountChoice(): string {
    if (
      !this.hasExplicitChoice &&
      this.parentAmountChoice === AmountChoice.Partial &&
      this.amountToPay <= 0
    ) {
      return ''
    }
    return this.parentAmountChoice || ''
  }

  get remainingCents(): number {
    return this.booking.totalCents - this.booking.paidCents
  }

  get currentDate(): Dayjs {
    return this.$store.getters[UtilityGetters.CurrentDate] || dayjs.utc()
  }

  get isFullPaymentRequired(): boolean {
    return this.currentDate.isSameOrAfter(
      dayjs.utc(this.booking.paymentDueDate),
    )
  }

  get stepperMaxDeposits(): number {
    return this.maxDeposits || 1
  }

  get amountNextDisabled(): boolean {
    return !this.amountChoice
  }

  get depositOptionVisible(): boolean {
    return this.booking.depositRemainingCents > 0 && !this.isFullPaymentRequired
  }

  @Watch('amountChoice', { immediate: true })
  syncCollapseWithAmountChoice() {
    this.collapseActiveName = this.amountChoice
  }

  @Watch('depositOptionVisible')
  @Watch('amountChoice')
  onDepositVisibilityOrChoice() {
    if (!this.depositOptionVisible && this.amountChoice === 'deposit') {
      if (this.isFullPaymentRequired) {
        this.onAmountChoiceChange('remaining')
      } else {
        this.onAmountChoiceChange('partial')
      }
    }
  }

  onCollapseInput(name: string) {
    if (!name) {
      return
    }
    if (name === this.amountChoice && this.hasExplicitChoice) {
      return
    }
    this.onAmountChoiceChange(name)
  }

  onAmountChoiceChange(choice: string) {
    if (!choice) {
      return
    }
    this.hasExplicitChoice = true
    if (choice === 'deposit' && !this.depositOptionVisible) {
      this.$emit('on-amount-choice-update', AmountChoice.Partial)
      this.$emit('on-amount-to-pay-update', (this.amountToPay / 100).toFixed(2))
      return
    }
    this.$emit('on-amount-choice-update', choice as AmountChoice)
  }

  onPartialFocus() {
    this.$emit('on-amount-choice-update', AmountChoice.Partial)
  }

  onEnteredPartialInput(amount: string) {
    this.$emit('on-entered-partial-amount-update', amount)
  }

  onEnteredPartialBlurFormat(amount: string) {
    this.$emit('on-entered-partial-amount-update', amount)
  }

  onDepositsAmountUpdate(value: number) {
    this.$emit('on-deposits-amount-update', value)
  }

  mounted() {
    if (
      this.parentAmountChoice === AmountChoice.Deposit ||
      this.parentAmountChoice === AmountChoice.Remaining ||
      this.amountToPay > 0
    ) {
      this.hasExplicitChoice = true
    }
  }
}
